export default __webpack_public_path__ + "static/7-149cfba0fa0aa9a7b2fa24cde66abd3c.webp";